<template>
  <SkeletonBlock
    :is-active="categoryStore.isSkeletonActive"
    :width="95"
    :height="48"
  >
    <slot />
  </SkeletonBlock>
</template>

<script setup lang="ts">
  import { SkeletonBlock } from '@experience/core-skeleton-lib';
  import { useCategoryStore } from '@/shared/store';

  const categoryStore = useCategoryStore();
</script>

<style lang="scss"></style>
